<div class="single-choice" class="col-md-12 text-center m-left-0 m-right-0 frankli-form-group">
  <select name="single-choice" [disabled]="disabled" id="single-choice" class="form-control m-bottom-20" (change)="select($event)">
    <option value=0 selected>Please select an answer...</option>
    <option *ngFor="let choice of question.surveyQuestionPossibleAnswers">
      {{choice.possibleAnswer}}
    </option>
  </select>
</div>
